// extracted by mini-css-extract-plugin
export var accent = "_bf-4";
export var add = "_bf-j";
export var addIcon = "_bf-k";
export var deleteIcon = "_bf-i";
export var disabled = "_bf-9";
export var ellipsis = "_bf-f";
export var error = "_bf-3";
export var form = "_bf-5";
export var hideFocus = "_bf-2";
export var icon = "_bf-7";
export var input = "_bf-e";
export var listItem = "_bf-h";
export var mediumHeight = "_bf-b";
export var noBorder = "_bf-8";
export var noRadius = "_bf-1";
export var shortHeight = "_bf-a";
export var tallHeight = "_bf-c";
export var textInput = "_bf-0";
export var vertical = "_bf-g";
export var veryTallHeight = "_bf-d";
export var widget = "_bf-6";